export const PRODUCT_ID_PATTERN = /^prod_[a-zA-Z0-9-_]+$/;
export const BOX_ID_PATTERN = /^box_[a-zA-Z0-9-_]+$/;
export const ENTITY_ID_EXTRACT_PATTERN = /(?:prod|box)_[a-zA-Z0-9-_]+/;

function normalizeId(value: string | null | undefined): string {
  return (value || "").trim();
}

export function isProductId(value: string | null | undefined): value is string {
  return PRODUCT_ID_PATTERN.test(normalizeId(value));
}

export function isBoxId(value: string | null | undefined): value is string {
  return BOX_ID_PATTERN.test(normalizeId(value));
}

export function isEntityId(value: string | null | undefined): value is string {
  return isProductId(value) || isBoxId(value);
}
